import { defineMessages } from 'react-intl-next';

export const messages: {
	searchLinkLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	searchLinkLabel: {
		id: 'dynamic-cards-search-page.search-link.label',
		defaultMessage: 'Search Link',
		description: 'Accessibility label for the search link component',
	},
});
